export default "__VITE_ASSET__c70eeaeb__"